'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _schedules = require('./schedules.service');

var _schedules2 = _interopRequireDefault(_schedules);

var _updates = require('./updates.service');

var _updates2 = _interopRequireDefault(_updates);

var _events = require('./events.service');

var _events2 = _interopRequireDefault(_events);

var _directory = require('./directory.service');

var _directory2 = _interopRequireDefault(_directory);

var _build = require('./build.service');

var _build2 = _interopRequireDefault(_build);

var _freightTime = require('./freightTime.service');

var _freightTime2 = _interopRequireDefault(_freightTime);

var _media = require('./media.service');

var _media2 = _interopRequireDefault(_media);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var servicesModule = _angular2.default.module('fiapiApp.services', []);

servicesModule.service('Schedules', _schedules2.default);

servicesModule.service('Updates', _updates2.default);

servicesModule.service('Events', _events2.default);

servicesModule.service('Directory', _directory2.default);

servicesModule.service('Build', _build2.default);

servicesModule.service('FreightTime', _freightTime2.default);

servicesModule.service('Media', _media2.default);

exports.default = servicesModule;


// WEBPACK FOOTER //
// ./client/components/services/index.js